import type {z} from "zod";
import {CreateSupplierOfferBody} from "@project/sdk/engineering/zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {supplierOfferFieldLabelIds} from "../../../messages/supplierOffers.messages";

export const createSupplierOfferFormSchema = CreateSupplierOfferBody.extend({
  supplierId: requiredStringSchema(
    CreateSupplierOfferBody.shape.supplierId,
    supplierOfferFieldLabelIds.supplierId,
  ),
  catalogItemId: requiredStringSchema(
    CreateSupplierOfferBody.shape.catalogItemId,
    supplierOfferFieldLabelIds.catalogItemId,
  ),
});
export type CreateSupplierOfferFormPayload = z.output<typeof createSupplierOfferFormSchema>;
export const draftCreateSupplierOfferFormSchema = createSupplierOfferFormSchema
  .extend({
    terms: CreateSupplierOfferBody.shape.terms.unwrap().partial().optional(),
  })
  .partial();
export type DraftCreateSupplierOfferFormPayload = z.output<
  typeof draftCreateSupplierOfferFormSchema
>;
